<script setup>

defineProps({
	class: {
		type: String,
		required: false,
		default: 'size-8'
	}
})

</script>

<template>
	<svg :class="class" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
		<radialGradient id="a23" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
			<stop offset="0" stop-color="currentColor"></stop>
			<stop offset=".3" stop-color="currentColor" stop-opacity=".9"></stop>
			<stop offset=".6" stop-color="currentColor" stop-opacity=".6"></stop>
			<stop offset=".8" stop-color="currentColor" stop-opacity=".3"></stop>
			<stop offset="1" stop-color="currentColor" stop-opacity="0"></stop>
		</radialGradient>
		<circle transform-origin="center" fill="none" stroke="url(#a23)" stroke-width="25" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
			<animateTransform begin="0s;start1.click" end="stop1.click" fill="freeze" type="rotate" attributeName="transform" calcMode="spline" dur=".66" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
		</circle>
		<circle transform-origin="center" fill="none" opacity=".2" stroke="currentColor" stroke-width="25" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
		</svg>
</template>

<style scoped>
.opacity-25 {
	opacity:0.25;
}
.opacity-75 {
	opacity:0.75;
}
</style>